module.exports = __webpack_public_path__ + "paris-c63f4edf4d0cc90d71c101aa8f45b438.bundle.jpg";